import { render, staticRenderFns } from "./exportDialog.vue?vue&type=template&id=521a3b8d&scoped=true"
import script from "./exportDialog.vue?vue&type=script&lang=js"
export * from "./exportDialog.vue?vue&type=script&lang=js"
import style0 from "./exportDialog.vue?vue&type=style&index=0&id=521a3b8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521a3b8d",
  null
  
)

export default component.exports